import React from "react";
import { Link } from "react-router-dom";

export const LOGO_URL = "/npi-logo.png";

export const Logo = ({ light = false, className = "", to = "/", size = "h-12" }) => {
  return (
    <Link to={to} className={`inline-flex items-center ${className}`} data-testid="logo-link" aria-label="NPI Strategic Sourcing Inc">
      <span className={light ? "inline-flex items-center justify-center bg-white rounded-sm px-3 py-2" : "inline-flex items-center"}>
        <img src={LOGO_URL} alt="NPI Strategic Sourcing Inc" className={`${size} w-auto object-contain`} />
      </span>
    </Link>
  );
};

export default Logo;
